import React, { ReactNode } from "react";

import "./loginBox.css";
import { useNavigate } from "react-router-dom";
import { useSafeNavigate } from "../../components/unloadBlocker";

interface LoginBoxProps {
    children: React.ReactNode;
    bottom?: ReactNode;
    login: boolean;
    title?: string;
}


export default function LoginBox(props: LoginBoxProps) {

    const navigate = useSafeNavigate(useNavigate());

    return <div className={"login-box page no-footer" + (props.login ? " login" : " signup")}>
        <div className="header">
            <h1>{props.title ? props.title : "Welcome back"}</h1>
            <div className="nav">
                <h3 onClick={() => {
                    navigate("/login");
                }}>Log In</h3>
                <h3 onClick={() => {
                    navigate("/signup");
                }}>Sign Up</h3>
                <hr/>
            </div>
        </div>
        <div className="content">
            {props.children}
        </div>
        <div className="bottom">
            {props.bottom}
        </div>
    </div>;
}